const ajaxContactForm = (formWrapperId, requireCheckmarkSelector) => {
  // Funksjon for å hente gclid fra URL
  function getGclid() {
    const urlParams = new URLSearchParams(window.location.search);
    const gclid = urlParams.get('gclid') || '';
    if (gclid) {
      console.log('gclid funnet i URL:', gclid);
    } else {
      console.log('Ingen gclid funnet i URL');
    }
    return gclid;
  }

  // Select the radio inputs
  const radioAdd = document.querySelector('.uni-track-add'); // "Bli kunde" (Ny kunde)
  const radioRemove = document.querySelector('.uni-track-rm'); // "Nåværende kunde"
  const targetElement = document.querySelector('.uni-track-target'); // Target element to toggle the class

  // Function to toggle the class based on the checked radio
  function toggleTargetClass() {
    if (radioAdd.checked) {
      targetElement.classList.add('uni-track-it');
    } else if (radioRemove.checked) {
      targetElement.classList.remove('uni-track-it');
    }
  }

  // Add change event listeners to both radio inputs
  if (radioAdd && radioRemove && targetElement) {
    radioAdd.addEventListener('change', toggleTargetClass);
    radioRemove.addEventListener('change', toggleTargetClass);

    // Run the function on page load in case a radio is pre-checked
    toggleTargetClass();
  } else {
    console.warn('One or more elements not found: .uni-track-add, .uni-track-rm, or .uni-track-target');
  }

  if (jQuery(".js-contact-form", formWrapperId).length) {
    const form = jQuery(".js-contact-form", formWrapperId)[0];

    // Sjekk om skjemaet allerede har en lytter
    if (form.dataset.ajaxListenerAdded) {
      console.log('Skjema allerede behandlet, hopper over:', form.id || 'unknown');
      return;
    }

    // Marker skjemaet som behandlet
    form.dataset.ajaxListenerAdded = 'true';

    form.addEventListener("submit", (event) => {
      event.preventDefault();
      ajaxContactForm(form); // Kaller den indre funksjonen
      return false;
    });
  }

  const ajaxContactForm = async (form) => {
    const goToStep = (step) => {
      jQuery(".js-first-step", form).addClass("hidden");
      jQuery(".js-second-step", form).addClass("hidden");
      jQuery(".js-third-step", form).addClass("hidden");
      jQuery(".js-loader-step", form).addClass("hidden");
      jQuery(`.js-${step}-step`, form).removeClass("hidden");
    };

    const hasLoader = jQuery(".js-loader-step", form).length > 0;

    jQuery(".js-validation-errors", form).html("");
    if (
      requireCheckmarkSelector &&
      jQuery(requireCheckmarkSelector).length &&
      !jQuery("#accept_eula").prop("checked")
    ) {
      jQuery(".js-validation-errors", form).html(
        "Du må gi samtykke for å sende inn skjema"
      );
      return false;
    }

    if (hasLoader) goToStep("loader");

    const formData = new FormData(form);
    const response = await fetch(window.ajax.url, {
      method: "POST",
      body: formData,
    });

    const result = await response.json();
    if (result.success) {
      console.log('AJAX-skjema innsending vellykket - Ny kode for Data Layer kjører nå');

      // Hent gclid og bestem trafikkilde
      const gclid = getGclid();
      const trafficSource = gclid ? 'google_ads' : 'organic';

      // Forbered data som skal pushes til Data Layer
      const dataLayerPayload = {
        'event': 'nyFormSubmission',
        'formId': form.id || 'unknown',
        'formClasses': form.className || '',
        'formAction': form.action || window.ajax.url, // Bruk AJAX URL hvis form.action ikke er tilgjengelig
        'gclid': gclid,
        'trafficSource': trafficSource
      };

      // Logg dataene som blir sendt til Data Layer
      console.log('Data Layer push utført med følgende data:', dataLayerPayload);

      // Push til Data Layer
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(dataLayerPayload);

      if (hasLoader) goToStep("third");
      form.reset();
    } else {
      if (hasLoader) goToStep("second");
      if (result && result.data && result.data.message) {
        jQuery(".js-validation-errors", form).html(result.data.message);
      } else {
        jQuery(".js-validation-errors", form).html(
          "Kunne ikke sende inn skjema akkurat nå. Prøv igjen senere"
        );
      }
    }
  };
};

export default ajaxContactForm;